import React from "react";

const WhyItsCheap: React.FC = () => (
  <section className="py-16 section-padding bg-deep-blue">
    <div className="container mx-auto max-w-3xl text-center">
      <h2 className="text-2xl md:text-3xl lg:text-4xl font-display font-bold text-white mb-5 leading-tight">
        How is STRAETCH so affordable?
      </h2>
      <p className="text-lg md:text-xl text-white/80 font-sans leading-relaxed">
        No sales team. No offices. No investors to service. STRAETCH is built by one marketing team,
        for teams like it, and that is the whole reason it costs a tenth of the alternative.
      </p>
      <p className="text-sm text-white/50 font-sans mt-5">
        Built and hosted in the EU. GDPR compliant. Cancel any time.
      </p>
    </div>
  </section>
);

export default WhyItsCheap;
